import feather from "feather-icons";

const AutomationIcon = ({ name, size = 18, className = "", strokeWidth = 1.8 }) => {
  const icon = feather.icons[name];
  if (!icon) return null;

  return (
    <svg
      aria-hidden="true"
      className={`automation-icon ${className}`}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      dangerouslySetInnerHTML={{ __html: icon.contents }}
    />
  );
};

export default AutomationIcon;
